import React from "react";
import { GlobalContext } from "../../../../../utils/globalprovider";
import ToolsBar from "../../../../../components/bases/toolsbar/toolsbar";


import SubtitleSelectionMode from "./SubtitleRange/subtitleselectionmode";
import SubtitleColorOptions from "./SubtitleRange/subtitlecoloroptions";


import imgexit from "./assets/exit.png"
import imgaccept from "./assets/accept.png"

import "./submenus.css"


class SubtitleColor extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);
        this.state =
        {
            toolsbar : {
                height: 26,
                items: [
                    {img: imgexit ,type:"button", disable:false,fr:"Fermer",en:"Close", nochangecolor:false, key:{key:"EXIT", cat:"actions"}},
                    {type:"space"},
                    {img: imgaccept ,type:"button", disable:false,fr:"Lancer",en:"Start", nochangecolor:false, key:{key:"START", cat:"actions"}},


                    ],
            },

        }

        this.state.parameters = {
            color: "center",
            applyColor: true,
        }

        // on recherche les valeurs par défault


        if ((this.props.current >=1) && (this.props.current <= this.props.subtitles.length))
        {

            this.props.subtitles[this.props.current-1].lines.forEach(element => {
                if ((element.len != 0) && (element.words.length>0))
                    this.state.parameters.color = element.words[0].color;
            });
            
        }


        this.selectionModeRef = React.createRef();
        this.positionOptionsRef = React.createRef();
        this.onClickToolsBar = this.onClickToolsBar.bind(this);
    }


    componentDidUpdate(prevProps)
    {

        var lastcolor = this.state.parameters.color;
        
        if (prevProps.current != this.props.current)
        {
            if ((this.props.current >=1) && (this.props.current <= this.props.subtitles.length))
            {

                this.props.subtitles[this.props.current-1].lines.forEach(element => {
                    if ((element.len != 0) && (element.words.length>0))
                        lastcolor = element.words[0].color;
                });
                
                var parameters = this.state.parameters;
                parameters.color  = lastcolor;
                this.setState({parameters: parameters});
                
            }

   

        }
    }


    onClickToolsBar(datas)
    {
        switch (datas.key)
        {
            case "START":
                if (this.props.onaction) 
                {
                    const ret = {
                        source: "parameters",
                        action:
                        {
                            
                            type: "color",
                            parameters: this.state.parameters,
                            range: this.selectionModeRef.current.getValues(),
                        }
                    };

                    console.log("retour", ret);
                    if (this.props.onaction) this.props.onaction (ret);
                }

                
                break;


            case "EXIT":
                if (this.props.onaction) this.props.onaction ({source:"submenu", submenu: {key:"EXIT"}});
                break;
        }
    }


    render()
    {
        const title = this.context.language=="fr"?"Couleur des sous-titres":"Colors";
                return (
                    <div className="submenuMain">
                            <div className="submenuTitle">{title}</div>

                            <div className="submenuCurrentDiv">
                                <SubtitleColorOptions ref = {this.positionOptionsRef}
                                    current = {this.props.current}
                                    color = {this.state.parameters.color}
                                    applyColor = {this.state.parameters.applyColor}
                                    onChange={(options) => {
                                        console.log(options);
                                        this.state.parameters = options;
                                    }}
                                />
                                <SubtitleSelectionMode ref = {this.selectionModeRef}
                                    value="current"
                                    onChange={(value) => console.log(value)}
                                    lineonly = {true}
                                    subtitles = {this.props.subtitles} 
                                    current = {this.props.current}
                                />                                
                            </div>
                            <div className="submenuBottom">
                            <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar} background={false}/>
                        </div>
                    
                    </div>
                )

    }

}

SubtitleColor.defaultProps = 
{
    subtitles:[],
    current:1,
}

export default SubtitleColor;



